import { createContext } from "react";

const HomePageContext = createContext(null);

export default HomePageContext;
